module.exports = __webpack_public_path__ + "img/cars-mobile-background-poster.476faa1d.jpg";